import * as ng from 'angular';
import { ComponentRegistration } from '../../../core';
import { Dto } from '../../../data';
import { IFrequentParkerAccountSummaryService } from './../';
let template = require('./dashboard-details.html');

class DashboardDetailsComponent extends ComponentRegistration {

    constructor() {
        super('dashboardDetails', {
            controller: DashboardDetailsController,
            templateUrl: template,
            controllerAs: 'vm',
            bindings: {
            }
        });
    }
}

interface IDashboardDetailsController {

}

class DashboardDetailsController implements IDashboardDetailsController {
    private static $inject: Array<string> = ['FrequentParkerAccountSummaryService'];
    private fpSummary: Dto.IFrequentParkerAccountSummary;

    //Bindings

    constructor(private FrequentParkerAccountSummaryService: IFrequentParkerAccountSummaryService) {

        console.log('DashboardDetailsController loading');
        this.activate();
    }

    public $onInit(): void {
        this.FrequentParkerAccountSummaryService.getFpaSummary()
            .then((fpSummary) => {
                this.fpSummary = fpSummary;
            });
    }

    public activate(): void {
        console.log('DashboardDetailsController loaded');
    }
}

let dashboardDetailsComponent = new DashboardDetailsComponent();
export default dashboardDetailsComponent;
export { dashboardDetailsComponent as DashboardDetailsComponent, IDashboardDetailsController, DashboardDetailsController }


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/components/admin/dashboard/dashboard-details.ts